import { render } from "./CrmDealKanbanDealDataModalRatingStars.vue?vue&type=template&id=85c76a12&scoped=true"
import script from "./CrmDealKanbanDealDataModalRatingStars.vue?vue&type=script&lang=js"
export * from "./CrmDealKanbanDealDataModalRatingStars.vue?vue&type=script&lang=js"

import "./CrmDealKanbanDealDataModalRatingStars.vue?vue&type=style&index=0&id=85c76a12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85c76a12"]])

export default __exports__